"use client";
import { jsx } from "react/jsx-runtime";
import Group from "../../layout/Group/Group.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Affix } from "@mantine/core";
import { forwardRef } from "react";
const _Floater = forwardRef((props, ref) => {
  const { children, position, sticky, style, ...rest } = props;
  return /* @__PURE__ */ jsx(
    Affix,
    {
      ...rest,
      ref,
      position,
      style: sticky ? { ...style, position: "sticky" } : style,
      withinPortal: !sticky,
      children: /* @__PURE__ */ jsx(Group, { justify: "center", align: "center", direction: "column", children })
    }
  );
});
_Floater.displayName = "Floater";
const Floater = sharedHandler(_Floater);
Floater.displayName = _Floater.displayName;
export {
  Floater as default
};
